import { render, staticRenderFns } from "./production-push-from-sales.vue?vue&type=template&id=022412aa"
import script from "./production-push-from-sales.vue?vue&type=script&lang=js"
export * from "./production-push-from-sales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports